import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AppFooter.css';

const AppFooter = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <p>
        &copy; 2024 {t('message.appTitle')} | <Link to="/privacy-policy">{t('message.privacyPolicy')}</Link>
      </p>
    </footer>
  );
};

export default AppFooter;
